import * as React from "react";
import {withRouter} from 'react-router-dom';

class ScrollToTop extends React.Component<any> {
    public componentDidUpdate(prevProps: any) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }

    public render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return null;
    }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/scroll-to-top.tsx